module.exports = __webpack_public_path__ + "static/introIllustration-67e164922b93275fffb18ca254fcf51a.svg";